/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JiraProjectAri } from '@atlassian/ari/jira';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import AssociateProjectToFieldSchemeModalQuery, {
	type AssociateProjectToFieldSchemeModalQuery as AssociateProjectToFieldSchemeModalQueryType,
} from './__generated__/AssociateProjectToFieldSchemeModalQuery.graphql';
import type { AssociateProjectToFieldSchemeModalEntrypointProps } from './AssociateProjectToFieldSchemeModal.entrypoint.types.tsx';

type EntryPointParams = { cloudId: string; projectId: string };

type AssociateProjectToFieldSchemeModalEntryPointComponent = EntryPointComponent<
	{
		associateProjectToFieldSchemeModalData: AssociateProjectToFieldSchemeModalQueryType;
	},
	{}, // AdditionalEntryPointsToLoad
	AssociateProjectToFieldSchemeModalEntrypointProps, // ComponentProps
	{} // ExtraProps
>;

export const associateProjectToFieldSchemeModalEntryPoint: EntryPoint<
	AssociateProjectToFieldSchemeModalEntryPointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<AssociateProjectToFieldSchemeModalEntryPointComponent>(
		/* webpackChunkName: "async-cmp-project-settings-fields-AssociateProjectToFieldSchemeModal" */ './AssociateProjectToFieldSchemeModal.tsx',
	),
	getPreloadProps: (params: EntryPointParams) => {
		return {
			queries: {
				associateProjectToFieldSchemeModalData: {
					parameters: AssociateProjectToFieldSchemeModalQuery,
					variables: {
						cloudId: params.cloudId,
						projectAri: JiraProjectAri.create({
							siteId: params.cloudId,
							projectId: params.projectId,
						}).toString(),
					},
					options: {
						fetchPolicy: 'network-only' as const,
					},
				},
			},
		};
	},
});
